module.exports = __webpack_public_path__ + "img/newchris-67.07c7f817.jpg";